import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginRequest } from "@services/loginRequest";
import { HttpClient, HttpClientModule, HttpHeaders } from "@angular/common/http";
import { LoginResponse } from "@services/loginResponse";
import { LocalDataService } from "@services/localDataService";
import { AlbumDetails } from "@/modals/album/albumDetails";
import { UntypedFormGroup } from '@angular/forms';
import { GalleryDetails } from "@/modals/gallery/galleryDetails";
import { AlbumImageDetails } from "@/modals/album/albumImageDetails";
import { NewsFeedDetails } from "@/modals/news-feed/NewsFeedDetails";
import { WebsiteDto } from "@/modals/website/WebsiteDto";
import { BlogDetails } from "@/modals/blogs/BlogDetails";
import { PressRelease } from "@/modals/press-release/PressRelease";
import { Observable } from "rxjs";
import { Client } from "@/modals/client/Client";
import { ConfigService } from "@services/config.service";
import { TestimonialDetails } from '@/modals/testimonial/testimonial-details';
import { SocialMediaDetails } from '@/modals/social-medial/social-media-details';
import { AuditoriumDetails } from '@/modals/auditorium/auditorium-details';
import { VolunteerDetails } from '@/modals/volunteer/volunteerDetails';
import { SponsorDetails } from '@/modals/sponsor/SponsorDetails';
import { FeedbackDetails } from '@/modals/feedback/FeedBackDetails';
import { ArtistDetails } from '@/modals/artist/ArtistDetails';

@Injectable({
  providedIn: "root",
})
export class AppService {
  public user: any = null;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private http: HttpClient,
    private localData: LocalDataService,
    private configService: ConfigService
  ) { }

  /*configService.getConfig().END_POINT = "https://tomcat3.varnik.cloud:8443/varnik-cms-ws";*/

  /*async loginByAuth({email, password}) {
      try {
        const token = await Gatekeeper.loginByAuth(email, password);
        localStorage.setItem('token', token);
        await this.getProfile();
        this.router.navigate(['/']);
        this.toastr.success('Login success');
      } catch (error) {
        this.toastr.error(error.message);
      }
    }*/

  async registerByAuth({ email, password }) {
    try {
      /* const token = await Gatekeeper.registerByAuth(email, password);
             localStorage.setItem('token', token);*/
      /* await this.getProfile();*/
      this.router.navigate(["/"]);
      this.toastr.success("Register success");
    } catch (error) {
      this.toastr.error(error.message);
    }
  }

  async loginByGoogle() {
    try {
      /*  const token = await Gatekeeper.loginByGoogle();
              localStorage.setItem('token', token);*/
      /* await this.getProfile();*/
      this.router.navigate(["/"]);
      this.toastr.success("Login success");
    } catch (error) {
      this.toastr.error(error.message);
    }
  }

  async registerByGoogle() {
    try {
      /*  const token = await Gatekeeper.registerByGoogle();
              localStorage.setItem('token', token);*/
      /* await this.getProfile();*/
      this.router.navigate(["/"]);
      this.toastr.success("Register success");
    } catch (error) {
      this.toastr.error(error.message);
    }
  }

  async loginByFacebook() {
    try {
      /* const token = await Gatekeeper.loginByFacebook();
             localStorage.setItem('token', token);*/
      /* await this.getProfile();*/
      this.router.navigate(["/"]);
      this.toastr.success("Login success");
    } catch (error) {
      this.toastr.error(error.message);
    }
  }

  async registerByFacebook() {
    try {
      /*   const token = await Gatekeeper.registerByFacebook();
               localStorage.setItem('token', token);*/
      /*await this.getProfile();*/
      this.router.navigate(["/"]);
      this.toastr.success("Register success");
    } catch (error) {
      this.toastr.error(error.message);
    }
  }

  /*async getProfile() {
      try {
        this.user = await Gatekeeper.getProfile();
      } catch (error) {
        this.logout();
        throw error;
      }
    }*/

  logout() {
    localStorage.removeItem("token");
    this.user = null;
    this.router.navigate(["/login"]);
  }

  //Check Login Request
  login(loginRequest: LoginRequest) {
    return this.http.post<LoginResponse>(
      this.configService.getConfig().END_POINT + "/auth/login",
      loginRequest
    );
  }

  //save Gallery Details
  saveGallery(websiteId: number) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/gallery/save/" +
      websiteId,
      null,
      { headers: this.localData.getHeaders() }
    );
  }

  //Get all gallery Image Details
  getAllGallery() {
    return this.http.get<GalleryDetails>(
      this.configService.getConfig().END_POINT +
      "/api/front-end/gallery/getAll",
      { headers: this.localData.getHeaders() }
    );
  }

  updateGalleryStatus(formData) {
    return this.http.put<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/gallery-image/update-status", formData,
      { headers: this.localData.getHeaders() }
    );
  }

  //get Albums Details
  getAlbums() {
    return this.http.get<AlbumDetails[]>(
      this.configService.getConfig().END_POINT + "/api/admin-dashboard/album/getAll",
      { headers: this.localData.getHeaders() }
    );
  }
  updateAlbumStatus(formData) {
    return this.http.put<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/album/update-status", formData,
      { headers: this.localData.getHeaders() }
    );
  }
  //save New Album Details
  addNewAlbum(userForm: UntypedFormGroup) {
    return this.http.post<AlbumDetails>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/album/save",
      userForm,
      { headers: this.localData.getHeaders() }
    );
  }

  //Update Album Details
  updateAlbum(userForm: UntypedFormGroup) {
    return this.http.post<AlbumDetails>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/album/update",
      userForm,
      { headers: this.localData.getHeaders() }
    );
  }

  //Delete Album Details
  deleteAlbum(albumId: number) {
    return this.http.delete<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/album/delete/" +
      albumId,
      { headers: this.localData.getHeaders() }
    );
  }

  //Delete Album Picture
  deleteAlbumPicture(pictureId: number) {
    return this.http.delete<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/gallery/deleteImage/" +
      pictureId,
      { headers: this.localData.getHeaders() }
    );
  }

  //Add Album Images
  addAlbumImages(formData: FormData, albumId: number) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/gallery/saveToAlbum/" +
      albumId,
      formData,
      { headers: this.localData.getImageHeaders() }
    );
  }

  //Get all website Details
  getWebsiteList() {
    return this.http.get<WebsiteDto[]>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/getMySiteList",
      { headers: this.localData.getSiteHeaders() }
    );
  }

  //Add Blog Details
  addBlogDetails(userForm: UntypedFormGroup) {
    return this.http.post<BlogDetails>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/blogPost/add",
      userForm,
      { headers: this.localData.getHeaders() }
    );
  }

  //Update Blog Details
  updateBlogDetails(userForm: UntypedFormGroup) {
    return this.http.put<BlogDetails>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/blogPost/update",
      userForm,
      { headers: this.localData.getHeaders() }
    );
  }

  //update Blog status
  updateBlogStatus(blogSeq: number, showStatus: string) {
    return this.http.put<BlogDetails>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/blogPost/update/" +
      blogSeq +
      "/" +
      showStatus,
      "",
      { headers: this.localData.getHeaders() }
    );
  }

  //Delete Album Details
  deleteBlog(blogSeq: number) {
    return this.http.delete<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/blogPost/deleteById/" +
      blogSeq,
      { headers: this.localData.getHeaders() }
    );
  }

  //Add Blog Image
  addBlogImage(formData: FormData, blogPostSeqId: number) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/blogPost/picture/upload?blogPostId=" +
      blogPostSeqId,
      formData,
      { headers: this.localData.getImageHeaders() }
    );
  }

  //Get all Blog Details
  getAllBlogDetails() {
    return this.http.get<BlogDetails[]>(
      this.configService.getConfig().END_POINT +
      "/api/front-end/blogPost/getAll",
      { headers: this.localData.getHeaders() }
    );
  }

  //add News Feed Details
  addNewsFeedDetails(userForm: UntypedFormGroup) {
    return this.http.post<NewsFeedDetails>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/news_feed/add",
      userForm,
      { headers: this.localData.getHeaders() }
    );
  }

  //Add News Feed Image
  addNewsFeedImage(formData: FormData, newsFeedId: number) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/news_feed/picture/upload?productId=" +
      newsFeedId,
      formData,
      { headers: this.localData.getImageHeaders() }
    );
  }

  //Get all News Feed Details
  getAllNewsFeedDetails(websiteName: string) {
    return this.http.get<NewsFeedDetails[]>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/newsfeed/get?website_name=" +
      websiteName,
      { headers: this.localData.getHeaders() }
    );
  }

  //Update News Feed Details
  updateNewsFeedDetails(userForm: UntypedFormGroup) {
    return this.http.put<NewsFeedDetails>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/news_feed/update",
      userForm,
      { headers: this.localData.getHeaders() }
    );
  }

  //update news feed status
  updateNewsFeedStatus(newsFeedId: number, showStatus: string) {
    return this.http.put<NewsFeedDetails>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/news_feed/update/" +
      newsFeedId +
      "/" +
      showStatus,
      "",
      { headers: this.localData.getHeaders() }
    );
  }

  //update news feed status
  updateNewsFeedImageStatus(newsFeedId: number, showImageStatus: string) {
    return this.http.put<NewsFeedDetails>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/news_feed/image_update/" +
      newsFeedId +
      "/" +
      showImageStatus,
      "",
      { headers: this.localData.getHeaders() }
    );
  }

  //Delete Album Details
  deleteNewsFeed(newsFeedId: number) {
    return this.http.delete<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/news_feed/deleteById/" +
      newsFeedId,
      { headers: this.localData.getHeaders() }
    );
  }

  //Get all News Feed Details
  getAllPressRelease() {
    return this.http.get<PressRelease[]>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/press-details/getAll",
      { headers: this.localData.getHeaders() }
    );
  }

  //Save Press Release Details
  savePressRelease(userForm: UntypedFormGroup) {
    return this.http.post<PressRelease>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/press-details/add",
      userForm,
      { headers: this.localData.getHeaders() }
    );
  }

  //Save Press PDF File
  addPressPDFFile(formData: FormData, pressId: number) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/press-details/file/upload?press_id=" +
      pressId,
      formData,
      { headers: this.localData.getImageHeaders() }
    );
  }

  //Get PDF File By Press ID
  getPDFByPressId(pressId: number): Observable<Blob> {
    return this.http.get(
      this.configService.getConfig().END_POINT +
      "/api/front-end/press-details/getFile/" +
      pressId,
      {
        headers: this.localData.getHeadersWithoutToken(),
        responseType: "blob",
      }
    );
  }

  //Update Press Release Details
  updatePressRelease(userForm: UntypedFormGroup) {
    return this.http.put<PressRelease>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/press-details/update",
      userForm,
      { headers: this.localData.getHeaders() }
    );
  }

  //update Press Release Details status
  updatePressReleaseStatus(pressId: number, showStatus: string) {
    return this.http.put<PressRelease>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/press-details/update/" +
      pressId +
      "/" +
      showStatus,
      "",
      { headers: this.localData.getHeaders() }
    );
  }

  //Delete Press Release Details
  deletePressRelease(pressId: number) {
    return this.http.delete<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/press-details/deleteById/" +
      pressId,
      { headers: this.localData.getHeaders() }
    );
  }

  //Save Client Details
  saveClientDetails(userForm: UntypedFormGroup) {
    return this.http.post<Client>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/companyPartner/add",
      userForm,
      { headers: this.localData.getHeaders() }
    );
  }

  //Save Client Image
  addClientImage(formData: FormData, clientId: number) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/companyPartner/picture/upload?id=" +
      clientId,
      formData,
      { headers: this.localData.getImageHeaders() }
    );
  }

  //Update Client Details
  updateClientDetails(userForm: UntypedFormGroup) {
    return this.http.put<Client>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/companyPartner/update",
      userForm,
      { headers: this.localData.getHeaders() }
    );
  }

  //update Client Details status
  updateClientDetailStatus(clientId: number, showStatus: string) {
    return this.http.put<Client>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/companyPartner/update/" +
      clientId +
      "/" +
      showStatus,
      "",
      { headers: this.localData.getHeaders() }
    );
  }

  //Get all client details
  getAllClientDetails() {
    return this.http.get<Client[]>(
      this.configService.getConfig().END_POINT +
      "/api/front-end/companyPartner/getAll",
      { headers: this.localData.getHeadersWithoutToken() }
    );
  }

  //Delete Client Details
  deleteClientDetails(clientId: number) {
    return this.http.delete<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/companyPartner/deleteById/" +
      clientId,
      { headers: this.localData.getHeaders() }
    );
  }

  // testimonial RestAPis
  // save api
  addTestimonial(formData: FormData) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/testimonial-details/add",
      formData,
      { headers: this.localData.getImageHeaders() }
    );
  }

  // update
  updateTestimonial(formData: FormData) {
    return this.http.put<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/testimonial-details/update",
      formData,
      { headers: this.localData.getImageHeaders() }
    );
  }

  updateTestimonialStatus(formData) {
    return this.http.put<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/testimonial-details/update-status", formData,
      { headers: this.localData.getHeaders() }
    );
  }

  // get api
  getTestimonial() {
    return this.http.get<TestimonialDetails[]>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/testimonial-details/getAll",
      { headers: this.localData.getHeaders() }
    );
  }

  // delete testimonial
  deleteTestimonial(testimonialSeq: number) {
    return this.http.delete<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/testimonial-details/deleteById/" +
      testimonialSeq,
      { headers: this.localData.getHeaders() }
    );
  }

  // social media
  // save
  addSocialMediaLinks(formData: FormData) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/social-media/add",
      formData,
      { headers: this.localData.getImageHeaders() }
    );
  }

  // update
  updateSocialMediaLinks(formData: FormData) {
    return this.http.put<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/social-media/update",
      formData,
      { headers: this.localData.getImageHeaders() }
    );
  }

  updateSocialMediaStatus(formData) {
    return this.http.put<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/social-media/update-status", formData,
      { headers: this.localData.getHeaders() }
    );
  }

  // get api
  getSocialMediaLinks() {
    return this.http.get<SocialMediaDetails[]>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/social-media/getAll",
      { headers: this.localData.getHeaders() }
    );
  }

  // delete testimonial
  deleteSocialMediaLinks(socialMediaSeq: number) {
    return this.http.delete<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/social-media/deleteById/" +
      socialMediaSeq,
      { headers: this.localData.getHeaders() }
    );
  }

  // Auditorium model

  //save auditorium details
  saveAuditoriumDetails(formData: FormData) {
    return this.http.post<AuditoriumDetails>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/auditorium-details/add",
      formData,
      { headers: this.localData.getHeaders() }
    );
  }

  //update auditorium details
  updateAuditoriumDetails(auditoriumSeq: number, formData: FormData) {
    return this.http.put<AuditoriumDetails>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/auditorium-details/update/" +
      auditoriumSeq,
      formData,
      { headers: this.localData.getHeaders() }
    );
  }

  //getall auditorium details
  getAllAuditoriumDetails() {
    return this.http.get<AuditoriumDetails[]>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/auditorium-details/getAll",
      { headers: this.localData.getHeaders() }
    );
  }

  //getall auditorium details
  updateAuditoriumStatus(formData) {
    return this.http.put<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/auditorium-details/update-status", formData,
      { headers: this.localData.getHeaders() }
    );
  }

  //Delete auditorium by id
  deleteAuditoriumById(auditoriumSeq: number) {
    return this.http.delete<any>(
      this.configService.getConfig().END_POINT +
      "/api/admin-dashboard/auditorium-details/deleteById/" +
      auditoriumSeq,
      { headers: this.localData.getHeaders() }
    );
  }

  getAllVolunteers() {
    return this.http.get<VolunteerDetails[]>(
      this.configService.getConfig().END_POINT + "/api/volunteerDetails/getAll",
      { headers: this.localData.getHeaders() }
    );
  }

  getVolunteerById(volunteerDetailsSeq: number) {
    return this.http.get<VolunteerDetails>(
      `${this.configService.getConfig().END_POINT}/api/volunteerDetails/get/${volunteerDetailsSeq}`,
      { headers: this.localData.getHeaders() });
  }

  getVolunteerResume(volunteerId: number) {
    return this.http.get(`${this.configService.getConfig().END_POINT}/api/volunteerDetails/get-resume/${volunteerId}`, {
      responseType: 'arraybuffer',  // force Angular to treat it as raw bytes
      headers: this.localData.getHeaders()
    });
  }

  getAdminUploadedFile(volunteerId: number) {
    return this.http.get(`${this.configService.getConfig().END_POINT}/api/volunteerDetails/get-admin-upload/${volunteerId}`, {
      responseType: 'arraybuffer',  // force Angular to treat it as raw bytes
      headers: this.localData.getHeaders()
    });
  }

  saveSponsorByAdmin(formData: FormData) {
    return this.http.post<SponsorDetails>(
      this.configService.getConfig().END_POINT + "/api/sponsorDetails/save/byAdmin", formData
    )
  }

  updateSponsorPaymentStatus(body: { sponsorDetailsId: number; paymentStatus: string }) {
    return this.http.put<SponsorDetails>(
      this.configService.getConfig().END_POINT + "/api/sponsorDetails/updatePaymentStatus",
      body,
      { headers: this.localData.getHeaders() }
    )
  }

  getSponsorLogo(sponsorDetailsId: number): Observable<ArrayBuffer> {
    return this.http.get(`${this.configService.getConfig().END_POINT}/api/sponsorDetails/getLogo/${sponsorDetailsId}`, {
      responseType: 'arraybuffer',
      headers: {
        'Accept': '*/*'
      }
    });
  }

  updateStatus(sponsorDetailsId: number, status: string): Observable<any> {
    return this.http.put(`${this.configService.getConfig().END_POINT}/api/sponsorDetails/updateStatus`, {
      sponsorDetailsId: sponsorDetailsId,
      status: status   // must be like "ACTIVE", "IN_ACTIVE"
    });
  }

  getAllSponsors() {

    return this.http.get<SponsorDetails[]>(
      this.configService.getConfig().END_POINT + "/api/sponsorDetails/getAll",
      { headers: this.localData.getHeaders() }
    );

  }

  getAllFeedbacks() {
    return this.http.get<FeedbackDetails[]>(
      this.configService.getConfig().END_POINT + "/api/feedbackDetails/getAll",
      { headers: this.localData.getHeaders() }
    );
  }

  updateFeedbackContentShow(payload: any) {
    return this.http.put(`${this.configService.getConfig().END_POINT}/api/feedbackDetails/updateContentShow`, payload,
      { headers: this.localData.getHeaders() }
    );
  }

  getAllArtists() {
    return this.http.get<ArtistDetails[]>(
      this.configService.getConfig().END_POINT + "/api/artistDetails/getAll",
      { headers: this.localData.getHeaders() }
    );
  }

  saveEventsDetails(payload: any) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT +
      "/api/mainEvent/save",
      payload,
      { headers: this.localData.getHeaders() }
    );
  }

  updateVolunteerResume(payload: any) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT + "/api/volunteerDetails/admin-upload",
      payload,
      { headers: this.localData.getHeaders() }
    );
  }


  getAllEvents() {
    return this.http.get<any[]>(
      this.configService.getConfig().END_POINT +
      "/api/mainEvent/getAll",
      { headers: this.localData.getHeaders() }
    );
  }

  getEventById(eventSeq: number) {
    return this.http.get<any>(
      this.configService.getConfig().END_POINT +
      `/api/mainEvent/getById/${eventSeq}`,
      { headers: this.localData.getHeaders() }
    );
  }

  getAllSubEventsByMainEventSeq(mainEventSeq: number) {
    return this.http.get<any[]>(
      this.configService.getConfig().END_POINT +
      `/api/subEvents/getByMainEvent/${mainEventSeq}`,
      { headers: this.localData.getHeaders() }
    );
  }

  deleteMainEventById(mainEventSeq: number) {
    return this.http.delete<any>(
      this.configService.getConfig().END_POINT +
      `/api/mainEvent/delete/${mainEventSeq}`,
      { headers: this.localData.getHeaders() }
    );
  }

  downloadPerformanceVideo(auditionCallRegSeq: number) {
    return this.http.get(
      this.configService.getConfig().END_POINT +
      `/api/audition-registration/get-performance-video/${auditionCallRegSeq}`,
      {
        responseType: 'blob',
        headers: this.localData.getHeaders()
      }
    );
  }

  getAllProductions() {
    return this.http.get<any[]>(
      this.configService.getConfig().END_POINT + "/api/audition-registration/get-all",
      { headers: this.localData.getHeaders() }
    );
  }


  deleteSubEventById(subEventId: number) {
    return this.http.delete<any>(
      this.configService.getConfig().END_POINT +
      `/api/subEvents/delete/${subEventId}`,
      { headers: this.localData.getHeaders() }
    );
  }

  getSubEventLogoById(subEventId: number) {
    return this.http.get(
      this.configService.getConfig().END_POINT +
      `/api/subEvents/getLogo/${subEventId}`,
      {
        responseType: 'blob',
      }
    );
  }

  getSubEventPosterImageById(subEventId: number) {
    return this.http.get(
      this.configService.getConfig().END_POINT +
      `/api/subEvents/getPosterImage/${subEventId}`,
      {
        responseType: 'blob',
      }
    );
  }

  updateMainEvent(payload: any) {
    return this.http.put<any>(
      this.configService.getConfig().END_POINT + '/api/mainEvent/update',
      payload,
      { headers: this.localData.getHeaders() }
    );
  }

  // Banner Image Methods
  saveBannerDetails(payload: any) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT +
      "/api/bannerDetails/save",
      payload,
      { headers: this.localData.getHeaders() }
    );
  }

  updateBannerDetails(payload: any) {
    return this.http.put<any>(
      this.configService.getConfig().END_POINT +
      "/api/bannerDetails/update",
      payload,
      { headers: this.localData.getHeaders() }
    );
  }

  getAllBanners() {
    return this.http.get<any[]>(
      this.configService.getConfig().END_POINT +
      "/api/bannerDetails/getAll");
  }

  getBannerImageById(bannerDetailsSeq: number) {
    return this.http.get(
      this.configService.getConfig().END_POINT +
      `/api/bannerDetails/getBanner/${bannerDetailsSeq}`,
      {
        responseType: 'blob',
      }
    );
  }

  deleteBannerById(bannerDetailsSeq: number) {
    return this.http.delete<any>(
      this.configService.getConfig().END_POINT +
      `/api/bannerDetails/delete/${bannerDetailsSeq}`,
      { headers: this.localData.getHeaders() }
    );
  }

}
